import { useEffect, useMemo, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import FormModal from "./form.modal";
import { SystemUserService } from "../../services/system-user";
import { UtilsService } from "../../services/utils";
import { StorageService } from "../../services/storage";
import { STORAGE } from "../../constants";

function UsersPage() {
  const account = StorageService.get(STORAGE.ACCOUNT);

  const [showModal, setShowModal] = useState({
    data: null,
    show: false,
  });

  const [list, setList] = useState<any[]>([]);

  const totalAdmins = useMemo( () => list.filter((l: any) => l.role === "admin").length, [list] );
  const totalCapturists = useMemo( () => list.filter((l: any) => l.role === "capturist").length, [list] );

  const remainingLicenses = useMemo(() => {
    switch (account.plan) {
      case "BÁSICO":
        return {
          admin: 1 - totalAdmins,
          capturist: 2 - totalCapturists,
        };
      case "PLATA":
        return {
          admin: 2 - totalAdmins,
          capturist: 3 - totalCapturists,
        };
      case "ORO":
        return {
          admin: 2 - totalAdmins,
          capturist: 6 - totalCapturists,
        };
      case "DIAMANTE":
        return {
          admin: 5 - totalAdmins,
          capturist: 15 - totalCapturists,
        };

      default:
        return {
          admin: 0,
          capturist: 0,
        };
    }
  }, [account, totalAdmins, totalCapturists]);

  const getList = async () => {
    const data = await SystemUserService.list();
    setList(data);
  };

  const handleModal = (refresh?: boolean) => {
    if (refresh) {
      getList();
    }
    setShowModal({ data: null, show: false });
  };

  const getDetailsPlan = () => {
    switch (account?.plan) {
      case "BÁSICO":
        return (
          <>
            <li>Un acceso web y móvil.</li>
            <li>Dos accesos solo en móvil.</li>
          </>
        );
      case "PLATA":
        return (
          <>
            <li>Dos accesos web y móvil.</li>
            <li>Tres accesos solo en móvil.</li>
          </>
        );
      case "ORO":
        return (
          <>
            <li>Dos accesos web y móvil.</li>
            <li>Seis accesos solo en móvil.</li>
          </>
        );
      case "DIAMANTE":
        return (
          <>
            <li>Cinco usuarios web y móvil.</li>
            <li>Quince accesos solo en móvil.</li>
          </>
        );
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Usuarios de sistema
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">
                        Configuración
                      </li>
                      <li className="breadcrumb-item text-gray-900">
                        Usuarios de sistema
                      </li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal({ data: null, show: true })}
                    >
                      <i className="ki-duotone ki-plus"></i> Agregar usuario
                    </button>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    <div className="card-body py-4">
                      <div className="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 ">
                        <i className="fa-solid fa-circle-exclamation fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
                        <div className="d-flex flex-column">
                          <h5 className="mb-1">¡Atención!</h5>
                          <span>
                            Actualmente estás utilizando el plan{" "}
                            <b>{account?.plan}</b>, el cual incluye:
                            <ul>{getDetailsPlan()}</ul>
                            Uso actual:
                            <ul>
                              <li>{totalAdmins} acceso web y móvil utilizado.</li>
                              <li>{totalCapturists} accesos móviles utilizados.</li>
                            </ul>
                            ¿Necesitas más licencias? Ponte en contacto con tu
                            agente de ventas.
                          </span>
                        </div>
                      </div>

                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                        id="kt_table_users_wrapper"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">ID</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Role: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Nombre</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Estatus</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Rol</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Fecha de creación</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Actions"
                                  className="text-end min-w-100px dt-orderable-none"
                                  colSpan={1}
                                  rowSpan={1}
                                >
                                  <span className="">Acciones</span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row) => (
                                <tr key={row._id}>
                                  <td>{row._id}</td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <p className="text-gray-800 m-0">
                                        {row.name}
                                      </p>
                                      <span>{row.email}</span>
                                    </div>
                                  </td>
                                  <td>
                                    {row.status ? (
                                      <div className="badge badge-success fw-bold">
                                        Activo
                                      </div>
                                    ) : (
                                      <div className="badge badge-danger fw-bold">
                                        Inactivo
                                      </div>
                                    )}
                                  </td>
                                  <td>{UtilsService.formatRole(row.role)}</td>
                                  <td>
                                    {UtilsService.dateFormat(row.created_at)}
                                  </td>
                                  <td className="text-end">
                                    <button
                                      className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                      onClick={() =>
                                        setShowModal({ show: true, data: row })
                                      }
                                    >
                                      Editar
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <FormModal
        show={showModal.show}
        data={showModal.data}
        users={list}
        setShow={handleModal}
      />
    </>
  );
}

export default UsersPage;
